import React from 'react';
import spinner from '../../../images/spinner.gif';

import './spinner.scss';

interface ISpinnerProps {
    classname?: object;
}

const Spinner = (props: ISpinnerProps) => (
    <div className={props.classname ? `${props.classname} spinner-wrapper` : 'spinner-wrapper'} >
        <img src={spinner} alt='loading...' />
    </div>
);

export default Spinner;